import {
  TABLE_LOAD_DATA,
  TABLE_LOAD_DATA_SUCCESS,
  TABLE_LOAD_DATA_FAILURE,
  TABLE_CLEAR_DATA,
  TABLE_CUSTOM_FILTER_UPDATE,
  TABLE_CUSTOM_FILTER_CLEAR,
  SET_TABLE_CHECKED_ITEMS,
  TABLE_CLICKED_ROW,
  TABLE_TOGGLE_ALL,
  TABLE_TOGGLE_SELECTION,
  SET_TABLE_FILTERED_DATA,
  CLEAR_TABLE_CHECKED_ITEMS,
} from './types/ListTableActionTypes';
import TableDefinitions from '../../TableDefinitions';

export function tableLoadData(tableId, type, parameters) {
  return {
    type: TABLE_LOAD_DATA,
    payload: {
      tableDefinition: TableDefinitions[tableId.tableId],
      tableId,
      appContext: type,
      params: parameters,
    },
  };
}

export function tableLoadDataSuccess(tableDefinition, mainTableId, tableData) {
  return {
    type: TABLE_LOAD_DATA_SUCCESS,
    payload: {
      tableDefinition,
      mainTableId,
      data: [...tableData],
    },
  };
}

export function tableLoadDataFailure(tableDefinition, mainTableId, error) {
  return {
    type: TABLE_LOAD_DATA_FAILURE,
    payload: {
      tableDefinition,
      mainTableId,
      error,
    },
  };
}

export function tableCheckItemsSetSuccess(payload) {
  return {
    type: SET_TABLE_CHECKED_ITEMS,
    payload: {
      checboxSelections: payload.selectedRows,
      listId: payload.tableDefinition.id,
    },
  };
}

export function tableFilteredDataSetSuccess(tableId, filteredData) {
  return {
    type: SET_TABLE_FILTERED_DATA,
    payload: {
      listId: TableDefinitions[tableId.tableId],
      visibleData: filteredData,
    },
  };
}

export function tableClickedRowSetSuccess(clickedRow) {
  return {
    type: TABLE_CLICKED_ROW,
    clickedRow: { ...clickedRow },
  };
}

/**
 * Returns parameters for cleared table
 * @param {TableDefinitionModel} tableDefinition
 */
export function tableClearData(tableDefinition = { tableDefinition: null }) {
  return {
    type: TABLE_CLEAR_DATA,
    payload: {
      tableDefinition,
    },
  };
}

export function updateTableCustomFilter(payload) {
  return {
    type: TABLE_CUSTOM_FILTER_UPDATE,
    payload,
  };
}

export function clearTableCustomFilter() {
  return {
    type: TABLE_CUSTOM_FILTER_CLEAR,
  };
}

export function tableToggleAll(payload) {
  return {
    type: TABLE_TOGGLE_ALL,
    payload,
  };
}

export function tableToggleSelection(payload) {
  return {
    type: TABLE_TOGGLE_SELECTION,
    payload,
  };
}

export function clearTableSelection(payload) {
  return {
    type: CLEAR_TABLE_CHECKED_ITEMS,
    payload,
  };
}
